import { SET_WEBPUSH_ANALYTICS_DATA } from '../constants/actionTypes';

export const setWebPushAnalyticsData = ({ analyticsData }) => ({
    type: SET_WEBPUSH_ANALYTICS_DATA,
    analyticsData
});
